import TechnicalProcess from "./technicalProcess";
export default TechnicalProcess;
